export default __webpack_public_path__ + "static/media/icon-veloe-background.b416fdb8.svg";